/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import {
    downloadReportErrorAction,
    downloadReportSuccessAction,
    fetchReportErrorAction,
    fetchReportPageSuccessAction,
    ReportsActions,
    ReportsActionType,
} from '../actions/reportsActions';
import { RootState } from '../store.typings';
import { catchError, exhaustMap, map, switchMap, takeUntil } from 'rxjs/operators';
import { DownloadReportsQueryParams, ReportsQueryParams } from '../api/reports/reportsClient.typings';
import { ReportsState } from '../reducers/reportsReducer';
import { from, of } from 'rxjs';
import { reportsClient } from '../api/reports/reportsClient';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';

type ReportsEpic = Epic<ReportsActions, ReportsActions, RootState>;

export const fetchAggregatesEpic: ReportsEpic = (action$, state$) => {
    return action$.pipe(
        ofType(ReportsActionType.FETCH_NEXT_REPORTS_PAGE_START),
        switchMap(() => {
            const state = state$.value.reportsReducer;
            const searchParams = getReportsQueryParams(state);

            return from(reportsClient.getAggregates(searchParams, state.isByDay)).pipe(
                map((list) => fetchReportPageSuccessAction(list)),

                catchError((err: AxiosError) =>
                    of(fetchReportErrorAction(parseError(err, i18n.t('ReportsScreen.errors.failedLoadReportsList')))),
                ),
                takeUntil(action$.pipe(ofType(ReportsActionType.EXIT_REPORTS_PAGE))),
            );
        }),
    );
};

function getReportsQueryParams(state: ReportsState): ReportsQueryParams {
    return {
        ...state.filterParams,
        limit: state.limit,
        afterKey: state.afterKey,
    };
}

export const aggregatesReportDownloadEpic: ReportsEpic = (action$, state$) => {
    return action$.pipe(
        ofType(ReportsActionType.DOWNLOAD_REPORT_START),
        exhaustMap((action) => {
            const state = state$.value.reportsReducer;
            const searchParams = getReportDownloadQueryParams(state);

            return from(reportsClient.downloadAggregatesDataReportFile(searchParams, action.payload)).pipe(
                map(() => downloadReportSuccessAction()),

                catchError((err: AxiosError) =>
                    of(
                        downloadReportErrorAction(
                            parseError(err, i18n.t('downloadings.errors.requestToCreateFileFailed')),
                        ),
                    ),
                ),
                takeUntil(action$.pipe(ofType(ReportsActionType.EXIT_REPORTS_PAGE))),
            );
        }),
    );
};

function getReportDownloadQueryParams(state: ReportsState): DownloadReportsQueryParams {
    return {
        ...state.filterParams,
    };
}
